"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribe = exports.publish = void 0;
const Ajv = require('ajv');
const events_1 = require("../events");
const { version } = require('../../package.json');
const ajv = new Ajv({ strict: false, useDefaults: true });
function validateEvent(event) {
    const schema = (0, events_1.getSchema)(event.name);
    return ajv.validate(schema, event.data);
}
function validateEventVersion(event) {
    const currentVersion = getCurrentVersion();
    return currentVersion == event.data._ev;
}
function getErrors(event) {
    const schema = (0, events_1.getSchema)(event.name);
    const compiledSchema = ajv.compile(schema);
    return compiledSchema.errors;
}
function showValidationErrors(event) {
    const errors = getErrors(event);
    if (errors) {
        let errorMessage = `[Senn Node Microfrontends Event Bus] ${event.name} event\nSchema validation failed with the following error(s):\n`;
        for (const error of errors) {
            errorMessage += `- ${error.schemaPath}: ${error.message}\n`;
        }
        console.error(errorMessage);
    }
}
function getCurrentVersion() {
    return version;
}
function publish(event) {
    const isValid = validateEvent(event);
    const libraryVersion = getCurrentVersion();
    if (isValid) {
        window.dispatchEvent(new CustomEvent(event.name, {
            detail: { ...event.data, _ev: libraryVersion }
        }));
    }
    else {
        showValidationErrors(event);
    }
}
exports.publish = publish;
function subscribe(eventName, handler, options) {
    const listenerHandler = ((event) => {
        const isValid = validateEvent({
            name: eventName,
            data: event.detail
        });
        if (isValid) {
            handler(event.detail);
        }
        else {
            const isVersionValid = validateEventVersion({
                name: eventName,
                data: event.detail
            });
            if (!isVersionValid) {
                const version = getCurrentVersion();
                console.error(`Library versions mismatch. Please update your library. Version for subscriber is ${version}. Version for publisher is ${event.detail._ev}`);
            }
            showValidationErrors({ name: eventName, data: event.detail });
        }
    });
    window.addEventListener(eventName, listenerHandler, options);
    return {
        unsubscribe: () => {
            window.removeEventListener(eventName, listenerHandler);
        }
    };
}
exports.subscribe = subscribe;
